/*firebase daniel start*/
import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: 'AIzaSyDl1Xbt1gE_D7N-7-hhR8eSr8WP2CQNmJE',
    authDomain: 'primi-mille-giorni-a4b82.firebaseapp.com',
    projectId: 'primi-mille-giorni-a4b82',
    storageBucket: 'primi-mille-giorni-a4b82.appspot.com',
    messagingSenderId: '767223845077',
    appId: '1:767223845077:web:9aae1c0717db255f3e525c',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
export const fapp = initializeApp(firebaseConfig);
export const messaging = getMessaging(fapp);
export const analytics = (() => {
    try {
        return getAnalytics(fapp);
    } catch (e) {
        return null;
    }
})();

export const messagingSwRegistrationPromise = navigator.serviceWorker.ready;

const isDebug =
    typeof window !== 'undefined' &&
    window.location.search.includes('firebase_debug=1');

onMessage(messaging, (payload) => {
    if (analytics) {
        try {
            logEvent(analytics, 'push_received', {
                delivery: 'foreground',
                ...payload?.data,
                ...(isDebug ? { debug_mode: 1 } : {}),
            });
        } catch (e) {}
    }
});

navigator.serviceWorker.onmessage = (event) => {
    const data = event.data;
    if (data?.type === 'FCM_BACKGROUND_MESSAGE') {
        if (analytics) {
            try {
                logEvent(analytics, 'push_received', {
                    delivery: 'background',
                    ...data?.payload?.data,
                    ...(isDebug ? { debug_mode: 1 } : {}),
                });
            } catch (e) {}
        }
    }
    if (data?.type === 'FCM_NOTIFICATION_CLICK') {
        if (analytics) {
            try {
                logEvent(analytics, 'push_click', {
                    ...data?.data,
                    ...(isDebug ? { debug_mode: 1 } : {}),
                });
            } catch (e) {}
        }
    }
    if (data?.type === 'FCM_NOTIFICATION_DISPLAYED') {
        if (analytics) {
            try {
                logEvent(analytics, 'push_displayed', {
                    ...data?.payload,
                    displayed_at: data?.displayedAt,
                    ...(isDebug ? { debug_mode: 1 } : {}),
                });
            } catch (e) {}
        }
    }
    if (data?.urlToRedirect) {
        window.location.href = data.urlToRedirect;
    }
};
